export default "data:text/javascript;base64,aW1wb3J0IFRUb2FzdHMgZnJvbSAiLi9UVG9hc3RzLnZ1ZSI7CgpleHBvcnQgZGVmYXVsdCBUVG9hc3RzOwo="